module.exports = __webpack_public_path__ + "img/PL.9ed561ed.svg";